import React, { useState } from "react";
import clsx from "clsx";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { LabelValue } from "models/common";
import DropdownStyles from "./styles";
type Props = {
  label: string;
  error?: boolean;
  values: LabelValue[];
  handleSelect: (event: React.ChangeEvent<{ value: unknown }>) => void;
  value: string;
};

const Placeholder = ({ children }) => {
  return <div>{children}</div>;
};
const Dropdown = ({ label, error, values, handleSelect, value }: Props) => {
  const classes = DropdownStyles();

  const customSelect = () => {
    return (
      <Select
        displayEmpty
        error={error}
        value={value !== null ? value : ""}
        className={clsx(classes.select)}
        onChange={handleSelect}
      >
        {values !== null && values !== undefined && values.length > 0
          ? values.map((item: LabelValue) => (
            <MenuItem
              key={item.value}
              value={item.value}
              style={{ fontSize: "14px !important" }}
              className={classes.labelItem}
            >
              {item.label}
              <span className={classes.lebelLegth}>{item.length}</span>
            </MenuItem>
          ))
          : null}
      </Select>
    );
  };

  return (
    <div className="longEnough mCustomScrollbar" data-mcs-theme="dark">
      <FormControl variant="filled" fullWidth className={classes.dropdownLabel} size="small"   >
        <InputLabel className={classes.classLabel}>{label}</InputLabel>
        {customSelect()}
      </FormControl>
    </div>
  );
};

export default Dropdown;
